import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    credentials: 'include',
  }),
  tagTypes: [
    'Profile',
    'RepairQuestion',
    'RepairRequest',
    'Review',
    'Warranty',
    'Blog',
    'Payment',
    'CallbackRequest',
  ],
  endpoints: () => ({}),
});
